import { render, staticRenderFns } from "./logicManagementForm.vue?vue&type=template&id=6ba6a6d4&scoped=true&"
import script from "./logicManagementForm.vue?vue&type=script&lang=js&"
export * from "./logicManagementForm.vue?vue&type=script&lang=js&"
import style0 from "./logicManagementForm.vue?vue&type=style&index=0&id=6ba6a6d4&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6ba6a6d4",
  null
  
)

export default component.exports